import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'components/organisms/player-position-stacking/actions';
import Const from 'constants';
import MultiSelect from 'components/atoms/dropdowns/multi-select';
import {showPopup} from 'helpers/modal';
import {getTeamNamesOfGames} from 'helpers/game-helper';
import {isPlayerStackType, assertSettingsAreValid} from 'components/organisms/player-position-stacking/helpers';
import {sortByProperty} from 'helpers/sorters';
import NumberHelper from 'helpers/number-helper';
import SliderAdapter from 'components/atoms/slider-adapter';
import SelectKeyPlayerLineupPosition from './select-key-player-lineup-position';
import SelectPlayersQuantity from './select-players-quantity';
import SelectStackType from './select-stack-type';
import SelectKeyPosition from './select-key-position';
import SelectTeamType from './select-team-type';
import SelectStackingPlayer from './select-stacking-player';
import SelectStackingPosition from './select-stacking-position';
import SelectKeyPlayer from './select-key-player';
import SecondaryStackType from './secondary-stack-type';
import SecondaryStackOptions from './secondary-stack-options';
import {StackItemFactory} from '../helpers';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';
import InputRadio from 'components/atoms/inputs/input-radio';

const defaultState = StackItemFactory.getStackItemStructure();

class Settings extends Component {
    constructor(props) {
        super(props);
        this.signature = null;
        this.state = cp(defaultState);
    }

    componentDidUpdate(prevProps) {
        const {stacking} = this.props;

        if (stacking.getSignature() !== this.signature) {
            this.signature = stacking.getSignature();
            this.setState(cp(defaultState));
        }
    }

    sortedPlayers(players) {
        return players.sort(sortByProperty('salary', 'desc'));
    }

    selectKeyPosition(value) {
        this.setState({
            keyPositions: value ? [value] : [],
            keyPlayers: [],
        });
    }

    selectKeyPlayerLineupPosition(value) {
        this.setState({keyPlayerLineupPosition: value});
    }

    selectKeyPlayer(value) {
        const {exclusionSettings} = this.state;
        exclusionSettings.exclusionType = Const.STACK_WITH_PLAYER_EXCLUSION;
        this.setState({
            keyPlayers: value ? [value] : [],
            exclusionSettings,
        });
    }

    selectPlayer(values) {
        const selectedPlayers = values.map((value) => String(value));

        this.setState({selectedPlayers});
    }

    excludePlayer(values) {
        const {exclusionSettings} = this.state;
        exclusionSettings.excludedPlayers = values.map((value) => String(value));
        this.setState({exclusionSettings});
    }

    excludeTeam(values) {
        const {exclusionSettings} = this.state;
        exclusionSettings.excludedTeams = values;
        this.setState({exclusionSettings});
    }

    selectStackType(value) {
        this.setState({type: value});
    }

    selectNumberPlayers(value) {
        this.setState({numberPlayers: Number(value)});
    }

    selectPosition(value) {
        this.setState({selectedPositions: value});
    }

    selectTeamType(value) {
        this.setState({isSameTeam: Boolean(value * 1)});
    }

    validateStack(settings) {
        try {
            assertSettingsAreValid(settings, this.props.players);
        } catch (e) {
            this.props.dispatch(showPopup(e.message));
            return false;
        }

        return true;
    }

    addStack() {
        const settings = {...this.state};

        if (this.validateStack(settings)) {
            this.props.dispatch(Action.do('addItemToPlayerPositionStacking', cp(settings)));
        }
    }

    onSelectStackWith(value) {
        this.setState({stackWith: value});
        if (isPlayerStackType(value)) {
            this.setExclusionIsEnable(false);
        }
    }

    setExclusionIsEnable(value) {
        const {exclusionSettings} = this.state;
        exclusionSettings.isExclusionEnabled = value;
        this.setState({exclusionSettings});
    }

    onSelectExclusionType(value) {
        const {exclusionSettings} = this.state;
        exclusionSettings.exclusionType = value;
        this.setState({exclusionSettings});
    }

    preparePlayers() {
        const {players} = this.props;
        const playersOnPosition = {'': []};

        Object.values(players.all()).map((player) => {
            player.positionName
                .split('/')
                .filter((posName) => !inArray(posName, Const.POSITION_STACK_AVOID_POSITIONS))
                .map((posName) => {
                    !(posName in playersOnPosition)
                        ? (playersOnPosition[posName] = [player])
                        : playersOnPosition[posName].push(player);
                });
        });

        return {...playersOnPosition};
    }

    getStackTypeView(params = {}) {
        const {className = 'form-control input-md'} = params;

        return (
            <SelectStackType
                key={`stackType-${this.state.type}`}
                className={className}
                value={this.state.type}
                onChange={::this.selectStackType}
            />
        );
    }

    getPlayersNumberView(params = {}) {
        const {className = 'form-control input-md'} = params;

        return (
            <SelectPlayersQuantity
                key={`playersQuantity-${this.state.numberPlayers}`}
                className={className}
                value={this.state.numberPlayers}
                onChange={::this.selectNumberPlayers}
            />
        );
    }

    getStackingPlayerView() {
        const {players} = this.props;

        return (
            <>
                {this.getStackTypeView()}
                {this.getPlayersNumberView()}
                <div className="form-text">of</div>
                <SelectStackingPlayer
                    key={`stackingPlayer-${this.state.selectedPlayers.join('')}`}
                    players={players}
                    values={this.state.selectedPlayers}
                    onChange={::this.selectPlayer}
                />
            </>
        );
    }

    getStackingPositionView() {
        return (
            <>
                {this.getStackTypeView()}
                {this.getPlayersNumberView()}
                <div className="form-text">of</div>
                <SelectStackingPosition
                    key={`stackingPosition-${this.state.selectedPositions.join('')}`}
                    positions={this.getPositionNames()}
                    values={this.state.selectedPositions}
                    onChange={::this.selectPosition}
                />
                <div className="form-text">from</div>
                <SelectTeamType
                    key={`teamType-${Number(this.state.isSameTeam)}`}
                    value={Number(this.state.isSameTeam)}
                    onChange={::this.selectTeamType}
                />
            </>
        );
    }

    getStackingView(stackWith) {
        if (stackWith === Const.STACK_WITH_PLAYER) {
            return this.getStackingPlayerView();
        } else if (stackWith === Const.STACK_WITH_POSITION) {
            return this.getStackingPositionView();
        }

        return '';
    }

    getExclusionTeamView() {
        const {games} = this.props;

        const options = getTeamNamesOfGames(games.getAllAsArr()).map((teamName) => {
            return {value: teamName, label: teamName};
        });

        return (
            <MultiSelect
                key={Const.STACK_WITH_TEAM_EXCLUSION}
                onSelect={::this.excludeTeam}
                options={options}
                placeholder={'Select team'}
            />
        );
    }

    getExclusionPlayerView() {
        const {players} = this.props;

        const playerOptions = this.sortedPlayers(Object.values(players.all())).map((player) => {
            return {value: player.playerId, label: player.name};
        });

        return (
            <MultiSelect
                key={Const.STACK_WITH_PLAYER_EXCLUSION}
                onSelect={::this.excludePlayer}
                options={playerOptions}
                placeholder={'Select player'}
            />
        );
    }

    getExclusionSettingsView() {
        const {
            keyPlayers,
            exclusionSettings: {exclusionType},
        } = this.state;

        let optionsView = '';
        if (exclusionType === Const.STACK_WITH_TEAM_EXCLUSION) {
            optionsView = this.getExclusionTeamView();
        } else if (exclusionType === Const.STACK_WITH_PLAYER_EXCLUSION) {
            optionsView = this.getExclusionPlayerView();
        }

        return (
            <>
                {!isEmpty(keyPlayers) ? null : (
                    <>
                        <InputRadio
                            label="Team"
                            value={Const.STACK_WITH_TEAM_EXCLUSION}
                            checked={Const.STACK_WITH_TEAM_EXCLUSION === exclusionType}
                            onChange={() => ::this.onSelectExclusionType(Const.STACK_WITH_TEAM_EXCLUSION)}
                        />
                        <InputRadio
                            label="Player"
                            value={Const.STACK_WITH_PLAYER_EXCLUSION}
                            checked={Const.STACK_WITH_PLAYER_EXCLUSION === exclusionType}
                            onChange={() => ::this.onSelectExclusionType(Const.STACK_WITH_PLAYER_EXCLUSION)}
                        />
                    </>
                )}
                <div className="exclude-select-holder">{optionsView}</div>
            </>
        );
    }

    getAddStackButtonView() {
        return (
            <button type="submit" onClick={::this.addStack} className="btn">
                Add Rule
            </button>
        );
    }

    canExclusionSettingsBeRendered(stackWith) {
        const {sportConfig} = this.props;

        return sportConfig.isGameTypeClassic() && !isPlayerStackType(stackWith);
    }

    canStackBoostBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isGameTypeClassic();
    }

    canKeyPlayerLineupPositionBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isGameTypeShowDownOrSingleGame();
    }

    canSecondaryStackBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isSportNfl() && sportConfig.isGameTypeClassic();
    }

    onChangeStackBoostPercent(value) {
        value = NumberHelper.prepareInt(value, 0).limitByRange(0, 100, 0).get();

        this.setState({stackBoostPercent: Number(value)});
    }

    getKeyPlayer() {
        return this.state.keyPlayers[0] ?? '';
    }

    getKeyPosition() {
        return this.state.keyPositions[0] ?? '';
    }

    getPositionNames() {
        const {sportConfig} = this.props;

        return sportConfig
            .getFilter('positions', [])
            .filter((position) => position.key !== 'FLEX')
            .map((position) => position.key);
    }

    render() {
        const {sportConfig, players} = this.props;

        if (isEmpty(players.all())) {
            return null;
        }

        const playersOnPosition = this.preparePlayers();

        return (
            <div className="white-box">
                <h3>Create New Rule</h3>
                <div className="gray-holder gap-y">
                    {this.canSecondaryStackBeRendered() ? (
                        <>
                            <SecondaryStackType />
                            <SecondaryStackOptions />
                        </>
                    ) : null}
                    {this.canStackBoostBeRendered() ? (
                        <div className="form-inline">
                            <div className="form-text">Stack Boost</div>
                            <SliderAdapter
                                className="slider-boost"
                                onChange={::this.onChangeStackBoostPercent}
                                prependInput
                                min={0}
                                max={100}
                                defaultValue={this.state.stackBoostPercent}
                                step={1}
                            />
                        </div>
                    ) : null}
                    <div className="form-inline">
                        <div className="form-text">If</div>
                        <SelectKeyPosition
                            key={`keyPosition-${this.getKeyPosition()}`}
                            className="input-md"
                            value={this.getKeyPosition()}
                            positions={this.getPositionNames()}
                            onChange={::this.selectKeyPosition}
                        />
                        <SelectKeyPlayer
                            key={`keyPlayer-${this.getKeyPlayer()}`}
                            players={Object.values(playersOnPosition?.[this.getKeyPosition()] ?? [])}
                            value={this.getKeyPlayer()}
                            onChange={::this.selectKeyPlayer}
                        />
                        {this.canKeyPlayerLineupPositionBeRendered() ? (
                            <>
                                <div className="form-text">is</div>
                                <SelectKeyPlayerLineupPosition
                                    key={`keyPlayerLineupPosition-${this.state.keyPlayerLineupPosition}`}
                                    value={this.state.keyPlayerLineupPosition}
                                    onChange={::this.selectKeyPlayerLineupPosition}
                                />
                                <div className="form-text">then stack with</div>
                            </>
                        ) : (
                            <div className="form-text">is in lineup then stack with</div>
                        )}
                    </div>
                    <div className="form-inline">
                        <InputRadio
                            label="Position"
                            value={Const.STACK_WITH_POSITION}
                            checked={Const.STACK_WITH_POSITION === this.state.stackWith}
                            onChange={() => ::this.onSelectStackWith(Const.STACK_WITH_POSITION)}
                        />
                        <InputRadio
                            label="Player"
                            value={Const.STACK_WITH_PLAYER}
                            checked={Const.STACK_WITH_PLAYER === this.state.stackWith}
                            onChange={() => ::this.onSelectStackWith(Const.STACK_WITH_PLAYER)}
                        />
                        {this.getStackingView(this.state.stackWith)}
                        {this.canExclusionSettingsBeRendered(this.state.stackWith) ? null : (
                            <div className="advanced-filter-actions">{this.getAddStackButtonView()}</div>
                        )}
                    </div>
                    {this.canExclusionSettingsBeRendered(this.state.stackWith) ? (
                        <div className="form-inline">
                            <InputCheckbox
                                className="md-label"
                                label="Exclude"
                                checked={this.state.exclusionSettings.isExclusionEnabled}
                                onChange={::this.setExclusionIsEnable}
                            />
                            {this.state.exclusionSettings.isExclusionEnabled ? this.getExclusionSettingsView() : null}
                            <div className="advanced-filter-actions">{this.getAddStackButtonView()}</div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, playerPositionStacking, playersData} = state;

    return {
        sportConfig,
        stacking: playerPositionStacking,
        players: playersData.players,
        games: playersData.games,
    };
}

export default connect(mapStatesToProps)(Settings);

export {Settings};
